export const formatCurrency = (value, currency = 'EUR') => {
	if (typeof value !== 'number') return value;

	// Default locale fallback
	const locale = 'fr-FR';

	try {
		return value.toLocaleString(locale, {
			style: 'currency',
			currency,
		});
	} catch (error) {
		// Fallback in case the currency code or locale fails
		return value.toLocaleString('fr-FR', {
			style: 'currency',
			currency: 'EUR',
		});
	}
};



export const formatExactTime = (dateInput) => {
	if (!dateInput) return null;
	const d = new Date(dateInput);

	// Manually build the string using local numbers
	const pad = (num) => String(num).padStart(2, '0');

	const datePart = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
	const timePart = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

	// We add the 'Z' at the end so MongoDB accepts it as a Date, 
	// but the numbers stay exactly as they were in your form.
	return `${datePart}T${timePart}.000Z`;
};